<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitNewCurrency">
      <div class="form-group">
        <label for="newCurrency_digital">{{$t('views.localization.digital_code')}}</label>
        <input
            id="newCurrency_digital"
            v-model="newCurrency.digital"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.newCurrency.digital.$error }"
        />
        <div v-if="submitted && $v.newCurrency.digital.$error" class="invalid-feedback">
          <span v-if="!$v.newCurrency.digital.required">{{$t('validatePhrases.requiredField')}}</span>
          <span v-if="!$v.newCurrency.digital.minValue">
                        {{$t('validatePhrases.minValue')}}: 1
                      </span>
          <span v-if="!$v.newCurrency.digital.minValue">
                        {{$t('validatePhrases.maxValue')}}: 9999
                      </span>
        </div>
      </div>
      <div class="form-group">
        <label for="newCurrency_letter">{{$t('views.localization.letter_code')}}</label>
        <input
            id="newCurrency_letter"
            v-model="newCurrency.letter"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.newCurrency.letter.$error }"
        />
        <div v-if="submitted && $v.newCurrency.letter.$error" class="invalid-feedback">
          <span v-if="!$v.newCurrency.letter.required">{{$t('validatePhrases.requiredField')}}</span>
          <span v-if="!$v.newCurrency.letter.minLength">
                        {{$t('validatePhrases.minLength')}}: 1
                      </span>
          <span v-if="!$v.newCurrency.letter.maxLength">
                        {{$t('validatePhrases.maxLength')}}: 4
                      </span>
        </div>
      </div>
      <div class="form-group">
        <label for="newCurrency_name">{{$t('views.localization.currency_name')}}</label>
        <input
            id="newCurrency_name"
            v-model="newCurrency.name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.newCurrency.name.$error }"
        />
        <div v-if="submitted && $v.newCurrency.name.$error" class="invalid-feedback">
          <span v-if="!$v.newCurrency.name.required">{{$t('validatePhrases.requiredField')}}</span>
          <span v-if="!$v.newCurrency.name.minLength">
                        {{$t('validatePhrases.minLength')}}: 2
                      </span>
          <span v-if="!$v.newCurrency.name.maxLength">
                        {{$t('validatePhrases.maxLength')}}: 30
                      </span>
        </div>
      </div>
      <button class="btn btn-sm btn-success" type="submit">{{$t('popularWords.add')}}</button>
    </form>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{$t('views.localization.currency_list')}}</h4>

        <div class="row mt-3">
          <div class="col-12">
            <table class="table table-hover mb-0">
              <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <th>
                  <div>
                    {{item.currency_name}} ({{item.digital_code}} / {{item.letter_code}})
                  </div>
                </th>
                <th>
                  <div class="button-items text-right">
                    <div @click="deleteCurrency(item.id)" class="btn btn-sm btn-danger">{{$t('popularWords.delete')}}</div>
                  </div>
                </th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

    <popup
        :closeButton="deletePopup.closeButton"
        :actionButton="deletePopup.actionButton"
        :actionClass="deletePopup.actionClass"
        :show="deletePopup.show"
        @closePopup="closeDeletePopup"
        @actionPopup="deletePopupSubmit"
    >
      <div slot="header">{{$t('views.localization.delete_currency')}}</div>
      <div slot="body">
        {{$t('views.localization.delete_currency_text')}}
      </div>
    </popup>

  </div>
</template>

<script>

import {maxLength, minLength, minValue, maxValue, required} from "vuelidate/lib/validators";
import axios from "axios";
import Popup from "@/components/Popup";

export default {
  name: "Currency",
  components: {Popup},
  data(){
    return {
      list: [],
      newCurrency: {
        name: '',
        digital: '',
        letter: ''
      },
      submitted: false,
      deletedId: 0,
      deletePopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.confirm'),
        actionClass: "btn-success"
      },
    }
  },
  props: {

  },
  watch: {
    list: function(val){
      this.$emit('updateList', val);
    }
  },
  computed: {

  },
  validations: {
    newCurrency: {
      name: { required, minLength: minLength(2), maxLength: maxLength(250) },
      letter: { required, minLength: minLength(1), maxLength: maxLength(4) },
      digital: { required, minValue: minValue(1), maxValue: maxValue(9999) }
    }
  },
  methods: {
    submitNewCurrency(){
      this.submitted = true;
      // stop here if form is invalid
      this.$v.newCurrency.$touch();
      if(!this.$v.newCurrency.$invalid){
        let formData = new FormData();
        formData.append("name", this.newCurrency.name);
        formData.append("digital", this.newCurrency.digital);
        formData.append("letter", this.newCurrency.letter);

        axios
            .post(`/v1/localization/add-currency`, formData)
            .then(resp => {
              this.list = resp.data;
              this.$store.dispatch("addNotification", {
                text: this.$t('popularWords.successfully'),
                time: 2,
                color: "success"
              });
            })
            .catch(err => {
              this.$store.dispatch("addNotification", {
                text: err.response.data.message,
                time: 6,
                color: "danger"
              });
            });
      }
    },
    deleteCurrency(id){
      this.deletedId = id;
      this.deletePopup.show = true;
    },
    closeDeletePopup(){
      this.deletePopup.show = false;
    },
    deletePopupSubmit(){
      let formData = new FormData();
      formData.append("id", this.deletedId);

      axios
          .post(`/v1/localization/delete-currency`, formData)
          .then(() => {
            this.$store.dispatch("addNotification", {
              text: this.$t('popularWords.deleted'),
              time: 2,
              color: "success"
            });
            this.getAll();
            this.closeDeletePopup();
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    getAll(){
      axios
          .get(`/v1/localization/get-currency`)
          .then(resp => {
            this.list = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    }
  },
  created() {
    this.getAll();
  }

};
</script>

<style scoped lang="css">

</style>
